import classNames from "@casino/external/classNames";
import Button from "@casino/legacyUi/Button";
import getSocialButtonStyle from "./helpers/getSocialButtonStyle";

type Props = React.ComponentProps<typeof Button> & {
  $mainButton?: boolean;
};

const SocialButtonElement: FC<Props> = ({
  $mainButton,
  className,
  ...rest
}) => {
  const styleClass = $mainButton ? getSocialButtonStyle() : undefined;

  return <Button className={classNames(styleClass, className)} {...rest} />;
};

export default SocialButtonElement;
